import '../loader/loader.css';

export const Loader = () => {

    return (
        <div className="loader">
          <img src="https://ik.imagekit.io/qsdtqu5hp/Infinity-1s-200px__3_.svg?updatedAt=1688203205031" alt="loader" />
        </div>
      );
}